<template>
  <div class="">
    <div
      class="toast fb fb-cross-center fb-main-center"
      v-show="isShow"
      :class="isShow ? 'fadein' : 'fadeout'"
    >
      <div>
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    message: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.toast {
  background-color: #f2f2f2;
  color: #000;
  border-radius: 18px;
  width: 112px;
  height: 40px;
  font-size: 11px;
  line-height: 16px;
  position: absolute;
  font-family: PingFangSC-Regular;
  left: 50%;
  top: 42%;
  transform: translate(-50%, -50%);
}
.fadein {
  animation: animate_in linear 1;
}
.fadeout {
  animation: animate_out linear 1;
  opacity: 0;
}
@keyframes animate_in {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@keyframes animate_out {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
</style>
